var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.2,
    height: 30.203,
    viewBox: "0 0 30.2 30.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_Titolo_Clienti",
    "data-name": "icona Titolo Clienti",
    transform: "translate(0.1 -0.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_377",
    "data-name": "Tracciato 377",
    d: "M14.125,9.09l11.013,2.2a1.857,1.857,0,0,1,1.487,1.839V25.98a1.88,1.88,0,0,1-1.875,1.889H13.5a.621.621,0,0,0,.625-.63v-.63H24.75a.629.629,0,0,0,.625-.63V13.133a.632.632,0,0,0-.488-.617L14.125,10.375Z",
    transform: "translate(3.375 2.312)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_378",
    "data-name": "Tracciato 378",
    d: "M20.125,14a.63.63,0,0,1,0,1.259h-2.5a.63.63,0,0,1,0-1.259Z",
    transform: "translate(4.25 3.586)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_379",
    "data-name": "Tracciato 379",
    d: "M20.125,17a.63.63,0,0,1,0,1.259h-2.5a.63.63,0,0,1,0-1.259Z",
    transform: "translate(4.25 4.364)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_380",
    "data-name": "Tracciato 380",
    d: "M20.125,20a.63.63,0,0,1,0,1.259h-2.5a.63.63,0,0,1,0-1.259Z",
    transform: "translate(4.25 5.143)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_381",
    "data-name": "Tracciato 381",
    d: "M14.25,27.262a.625.625,0,1,1-1.25,0V9.63a.672.672,0,0,1,.225-.491.653.653,0,0,1,.525-.126l.5.1V27.262Z",
    transform: "translate(3.25 2.288)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_382",
    "data-name": "Tracciato 382",
    d: "M13.875,23v.63a.621.621,0,0,0,.625.63h-5a.621.621,0,0,0,.625-.63V23Z",
    transform: "translate(2.375 5.921)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_383",
    "data-name": "Tracciato 383",
    d: "M11.125,5a.63.63,0,0,1,0,1.259h-2.5A.63.63,0,0,1,8.625,5Z",
    transform: "translate(2 1.251)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_384",
    "data-name": "Tracciato 384",
    d: "M11.75,8.63a.621.621,0,0,1-.625.63h-2.5A.63.63,0,0,1,8.625,8h2.5A.621.621,0,0,1,11.75,8.63Z",
    transform: "translate(2 2.029)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_385",
    "data-name": "Tracciato 385",
    d: "M11.125,11a.63.63,0,0,1,0,1.259h-2.5a.63.63,0,0,1,0-1.259Z",
    transform: "translate(2 2.807)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_386",
    "data-name": "Tracciato 386",
    d: "M11.125,14a.63.63,0,0,1,0,1.259h-2.5a.63.63,0,0,1,0-1.259Z",
    transform: "translate(2 3.586)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_387",
    "data-name": "Tracciato 387",
    d: "M6.75,14.63a.621.621,0,0,1-.625.63h-2.5a.63.63,0,0,1,0-1.259h2.5A.621.621,0,0,1,6.75,14.63Z",
    transform: "translate(0.75 3.586)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_388",
    "data-name": "Tracciato 388",
    d: "M6.125,5a.63.63,0,0,1,0,1.259h-2.5A.63.63,0,0,1,3.625,5Z",
    transform: "translate(0.75 1.251)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_389",
    "data-name": "Tracciato 389",
    d: "M6.125,8a.63.63,0,0,1,0,1.259h-2.5A.63.63,0,0,1,3.625,8Z",
    transform: "translate(0.75 2.029)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_390",
    "data-name": "Tracciato 390",
    d: "M6.125,11a.63.63,0,0,1,0,1.259h-2.5a.63.63,0,0,1,0-1.259Z",
    transform: "translate(0.75 2.807)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_391",
    "data-name": "Tracciato 391",
    d: "M10.25,18.889a.629.629,0,0,0-.625-.63H5.875a.621.621,0,0,0-.625.63v5.668H4V18.889A1.88,1.88,0,0,1,5.875,17h3.75A1.88,1.88,0,0,1,11.5,18.889v5.668H10.25Z",
    transform: "translate(1 4.364)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_392",
    "data-name": "Tracciato 392",
    d: "M5.25,23H11.5v.63a.621.621,0,0,1-.625.63H4.625A.621.621,0,0,1,4,23.63V23Z",
    transform: "translate(1 5.921)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_393",
    "data-name": "Tracciato 393",
    d: "M2.188.205l13.738,2.1A1.878,1.878,0,0,1,17.5,4.172V11.4l-.5-.1a.653.653,0,0,0-.525.126.672.672,0,0,0-.225.491V4.172a.635.635,0,0,0-.525-.63L1.988,1.452a.344.344,0,0,0-.113-.013.587.587,0,0,0-.4.151.6.6,0,0,0-.225.479V28.291a.629.629,0,0,0,.625.63H5v.63a.621.621,0,0,0,.625.63H1.875A1.88,1.88,0,0,1,0,28.291V2.069A1.86,1.86,0,0,1,.663.633,1.866,1.866,0,0,1,2.188.205Z",
    transform: "translate(0 0)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerTitle);
export default __webpack_public_path__ + "static/media/customer_title.520f9fa0c454a153384552045a89768b.svg";
export { ForwardRef as ReactComponent };